import { Component, DOCUMENT, inject } from '@angular/core';

const ROUTING_COOKIE = 'zp_panel=clickhouse';

@Component({
    selector: 'zp-toolbar-report-backend',
    templateUrl: './toolbar-report-backend.component.html',
    standalone: true
})
export class ToolbarReportBackendComponent {

    public readonly visible = inject(DOCUMENT).cookie
        .split(';')
        .map((entry) => entry.trim())
        .includes(ROUTING_COOKIE);

}
